import Profile from "@/components/pages/Profile"
import useBackButton from "@/hooks/useBackButton"

const ProfilePage = () => {
  useBackButton()
  return <Profile />
}

export default ProfilePage
